import IconBase from "./IconBase";

// Many values under one field — a bulleted list.
const RefArrayIcon = (props) => (
    <IconBase {...props}>
        <circle cx="4.5" cy="7" r="1.15" fill="currentColor" stroke="none" />
        <circle cx="4.5" cy="12" r="1.15" fill="currentColor" stroke="none" />
        <circle cx="4.5" cy="17" r="1.15" fill="currentColor" stroke="none" />
        <path d="M9 7h11" />
        <path d="M9 12h11" />
        <path d="M9 17h11" />
    </IconBase>
);

export default RefArrayIcon;
